<script setup lang="ts">
	const { isVisible, animatedCardsRefs } = useAnimationAppearance({
		delay: 200,
		rootMargin: '80px',
	});
</script>

<template>
	<section id="contact" class="contact-section" itemscope itemtype="https://schema.org/Organization">
		<h2 class="contact-section__title">Наши контакты</h2>
		<div class="contact-section__links-list">
			<a
				:ref="(el) => (animatedCardsRefs[0] = el)"
				:href="CONTACTS.phone.link"
				class="links-list__link button button--secondary"
				itemprop="telephone"
				:class="{ 'is-visible': isVisible[0] }"
			>
				<Icon name="local:phone-call" class="link-icon" />
				{{ CONTACTS.phone.text }}
			</a>
			<a
				:ref="(el) => (animatedCardsRefs[1] = el)"
				:href="CONTACTS.email.link"
				class="links-list__link button button--secondary"
				itemprop="email"
				:class="{ 'is-visible': isVisible[1] }"
			>
				<Icon name="local:mail" class="link-icon" />
				{{ CONTACTS.email.text }}
			</a>
			<a
				:ref="(el) => (animatedCardsRefs[2] = el)"
				:href="CONTACTS.telegram.link"
				target="_blank"
				rel="noopener noreferrer"
				class="links-list__link button button--secondary"
				itemprop="sameAs"
				:class="{ 'is-visible': isVisible[2] }"
			>
				<Icon name="local:telegram" class="link-icon" />
				{{ CONTACTS.telegram.text }}
			</a>
		</div>
		<div class="contact-section__details-list">
			<div class="details-list__details-item">
				<div class="details-item__name details-item__name--row">Наименование компании:</div>
				<h3 class="details-item__value" itemprop="name">ООО «АГЕНТСТВО ПРАВИЛЬНЫХ ПЕРЕВОЗОК»</h3>
			</div>
			<div class="details-list__details-item">
				<div class="details-item__name">ИНН:</div>
				<div class="details-item__value" itemprop="taxID">7300030591</div>
			</div>
			<div class="details-list__details-item">
				<div class="details-item__name">КПП:</div>
				<div class="details-item__value">730001001</div>
			</div>
			<div class="details-list__details-item">
				<div class="details-item__name">ОГРН:</div>
				<div class="details-item__value" itemprop="identifier">1247300002575</div>
			</div>
			<div class="details-list__details-item">
				<div class="details-item__name">Юридический адрес:</div>
				<div
					class="details-item__value"
					itemprop="address"
					itemscope
					itemtype="https://schema.org/PostalAddress"
				>
					<span itemprop="postalCode">432027</span>
					,
					<span itemprop="addressRegion">Ульяновская обл</span>
					,
					<span itemprop="addressLocality">г Ульяновск</span>
					,
					<span itemprop="area">Ленинский р-н</span>
					,
					<span itemprop="streetAddress">ул Казанская, д 1А, помещ 13</span>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
	.contact-section__title {
		font-size: var(--font-size-title);
		font-weight: 700;
		margin-bottom: 15px;
		color: var(--color-tertiary);
	}
	.contact-section__links-list {
		display: grid;
		grid-template-columns: 1fr;
		gap: 12px;
		margin-bottom: 15px;
	}
	.links-list__link {
		font-size: 24px;
		width: 100%;
		height: 79px;
		border-radius: 52px;
		transform: scale(0.6);
		opacity: 0;
		transition: transform ease-in 0.5s, opacity ease-in 0.5s, background-color ease-in-out 0.3s;
		&.is-visible {
			transform: scale(1);
			opacity: 1;
		}
	}
	.link-icon {
		width: 29px;
		height: 29px;
	}
	.contact-section__details-list {
		display: grid;
		gap: 12px;
	}
	.details-list__details-item {
		display: block;
		gap: 10px;
		align-items: baseline;
	}
	.details-item__name {
		display: inline;
		font-size: 20px;
		font-weight: 700;
		margin-right: 0.4em;
		&.details-item__name--row {
			display: block;
		}
	}
	.details-item__value {
		display: inline;
		font-size: 20px;
	}

	@media (min-width: 1240px) {
		.contact-section__title {
			margin-bottom: 25px;
		}
		.contact-section__links-list {
			grid-template-columns: 1fr 1fr 1fr;
			gap: 24px;
			margin-bottom: 25px;
		}
		.links-list__link {
			font-size: 28px;
			width: 100%;
			height: 104px;
			border-radius: 52px;
		}
		.link-icon {
			width: 34px;
			height: 34px;
		}
		.contact-section__details-list {
			display: grid;
			gap: 15px;
		}
		.details-list__details-item {
			display: flex;
			gap: 10px;
			align-items: baseline;
		}
		.details-item__name {
			display: block;
			font-size: 20px;
			font-weight: 700;
		}
		.details-item__value {
			display: block;
			font-size: 20px;
		}
	}
</style>
